import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountSummaryResolved } from './account-summary.resolver';
import { DataSharingService } from 'src/app/services/login-page/data-sharing.service';
import { LocalStorageService } from 'src/app/services/global/local-storage.service';

@Component({
  selector: 'app-account-summary-switch',
  template: `
    <ng-container *ngIf="resolved">
      <ng-container *ngIf="resolved.useInvoiceLevelView; else accountView">
        <app-obpp-invoice-summary-page
          [openedSummaryResponse]="resolved.openedSummaryResponse"
          [uname]="resolved.uname">
        </app-obpp-invoice-summary-page>
      </ng-container>
      <ng-template #accountView>
        <obpp-account-summary
          [openedSummaryResponse]="resolved.openedSummaryResponse">
        </obpp-account-summary>
      </ng-template>
    </ng-container>
  `,
})
export class AccountSummarySwitchComponent implements OnInit {
  resolved!: AccountSummaryResolved;

  constructor(
    private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.resolved = this.route.snapshot.data['accountSummary'];

    const isInvoiceFlow = this.resolved.useInvoiceLevelView;
    // Persist in localStorage so the tabs component can read it on init / refresh
    this.localStorageService.set('invoiceOnlyJourney', isInvoiceFlow);
    // Also emit via BehaviorSubject so the tabs component reacts immediately
    this.dataSharingService.hideDisputeTab.next(isInvoiceFlow);
  }
}
